@if (visible()) {
<div class="fixed inset-0 z-[120] flex items-center justify-center p-4">
  <div class="absolute inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity"
    (click)="closed.emit()"></div>

  <div
    class="relative bg-white rounded-xl shadow-2xl border border-slate-300/50 max-w-[450px] w-full p-8 animate-in fade-in zoom-in duration-200">
    <div class="flex items-start gap-4 mb-8">
      <div [class]="type() === 'success' ? 'bg-emerald-50 text-emerald-600' : 'bg-rose-50 text-rose-600'"
        class="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0">
        @if (type() === 'success') {
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7" />
        </svg>
        } @else {
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        }
      </div>
      <div class="flex-1 pt-1">
        <p class="text-[14px] text-slate-600 font-medium leading-relaxed">
          {{ message() }}
        </p>
      </div>
    </div>

    <div class="flex justify-end gap-3">
      @if (showViewButton()) {
      <button (click)="view.emit()"
        class="min-w-[80px] px-6 py-2.5 bg-white text-slate-700 border border-slate-300 text-[13px] font-bold rounded-xl hover:scale-105 transition-all shadow-md active:scale-95 outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary">
        View Article
      </button>
      }
      <button #okBtn (click)="closed.emit()"
        class="min-w-[80px] px-6 py-2.5 bg-gradient-primary text-white text-[13px] font-bold rounded-xl hover:scale-105 transition-all shadow-md active:scale-95 outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary">
        OK
      </button>
    </div>
  </div>
</div>
}
